<h2>Dashboard</h2>
<ot-select-box [(ngModel)]="dealType">
  <ot-select-item value="all">All Deals</ot-select-item>
  <ot-select-item value="S">Sale</ot-select-item>
  <ot-select-item value="R">Rental</ot-select-item>
</ot-select-box>